module.exports = __webpack_public_path__ + "img/3.7388bf7e.png";